import { cleanState } from '@src/components/OMS/CareOrderFormView/CareOrderSlice';
import { openView } from '@src/components/OMS/OMSSlice';
import { OMSView } from '@src/components/OMS/OMSView';
import {
  ACTION,
  Button,
  ButtonVariants,
  FormControlSizes,
  HStack,
  IconName,
  MixpanelEvent,
  useDisclosure,
  useMixpanel,
} from '@talos/kyoko';
import { useCallback } from 'react';
import { useFeatureFlag, useRoleAuth } from '../../../hooks';
import { useAppStateDispatch } from '../../../providers/AppStateProvider';
import { BasketDetailsImportButton } from './BasketDetailsImport/BasketDetailsImportButton';
import { CareOrderImportDialog } from './CareOrderImport/CareOrderImportDialog';

export function CareOrderActionButtons() {
  const dispatch = useAppStateDispatch();
  const { isAuthorized } = useRoleAuth();
  const { enableImportBasketDetails, enableCareOrderWriting } = useFeatureFlag();
  const mixpanel = useMixpanel();
  const showImportBasketDetails =
    enableImportBasketDetails && isAuthorized(ACTION.EDIT_BASKET) && enableCareOrderWriting;
  const showImportCareOrdersButton = enableCareOrderWriting;
  const showNewCareOrderButton = enableCareOrderWriting;
  const importDialog = useDisclosure();

  const handleClickNewCareOrder = useCallback(() => {
    mixpanel.track(MixpanelEvent.OpenCareOrderForm);
    dispatch(cleanState());
    dispatch(openView(OMSView.CareOrderForm));
  }, [dispatch, mixpanel]);

  const handleClickImport = useCallback(() => {
    importDialog.open();
  }, [importDialog]);

  return (
    <>
      <HStack gap="spacing8">
        {showImportCareOrdersButton && (
          <Button
            size={FormControlSizes.Small}
            startIcon={IconName.DocumentUpload}
            onClick={handleClickImport}
            data-testid="import-care-orders-button"
          >
            Import Care Orders
          </Button>
        )}
        {showImportBasketDetails && <BasketDetailsImportButton />}
        {showNewCareOrderButton && (
          <Button
            size={FormControlSizes.Small}
            variant={ButtonVariants.Primary}
            startIcon={IconName.Plus}
            onClick={handleClickNewCareOrder}
            data-testid="new-care-order-button"
          >
            New Care Order
          </Button>
        )}
      </HStack>
      <CareOrderImportDialog {...importDialog} />
    </>
  );
}
